export const API_URI = process.env.REACT_APP_API_URI;
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;
export const APPLE_APP_ID = process.env.REACT_APP_APPLE_APP_ID;
export const GLIP_CLIENT_ID = process.env.REACT_APP_GLIP_CLIENT_ID;
